import { render } from "./wPchangeQuantity.vue?vue&type=template&id=36e648e1&scoped=true"
import script from "./wPchangeQuantity.vue?vue&type=script&lang=js"
export * from "./wPchangeQuantity.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e648e1"]])

export default __exports__